import {isNullOrUndefined} from "../../../services/Validator";

export default function GlossaryLetterText({letter}) {
    // Used in GlossaryTermsByLetterList to display single letter
    // that contains terms

    // BUILD
    if (isNullOrUndefined(letter))
        return null
    return (
        <div className={"sticky top-0 z-10 h-[32px] min-h-[32px]"}>
            <div className={"h-full flex justify-start items-center px-[24px] bg-[linear-gradient(to_right,theme(colors.backgroundLight4)_0%,theme(colors.backgroundLight4)_98%,transparent_100%)]"}>
                <span className="text-[14px] font-semibold text-primaryLight3">
                    {letter}
                </span>
            </div>
        </div>
    );
}